import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService } from '../api/api.service';
const userAndGroupMock = require('./layout-configuration/user-group.json');

@Injectable({
  providedIn: 'root'
})
export class UserAdministrationService {
  getAllUsersPath = '/ims/v1/users/';
  getAllGroupsPath = '/ims/v1/users/groups/';
  getAllRolesPath = '/ims/v1/users/roles/';

  disableUserPath = '/ims/v1/users/disable';
  enableUserPath = '/ims/v1/users/enable';
  getLicensePath = '/licensing/licenses';
  getAllLicensePath = '/licensing/licenses';

  constructor(private readonly apiService: ApiService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getUserAdministrationBoard$(): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return of(userAndGroupMock);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getUsers$(): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(this.getAllUsersPath, {});
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getGroups$(): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(this.getAllGroupsPath, {});
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getRoles$(): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(this.getAllRolesPath, {});
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getBaseLicence(): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(this.getLicensePath, {});
  }

  //used if dynamic user administration content rendering
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  retrieveWidgetDataQuery$(url: any, data: any): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.post$<any>('/' + url, data);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  disableUser$(userList: string[]): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.post$<any>(this.disableUserPath, userList);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  enableUser$(userList: string[]): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.post$<any>(this.enableUserPath, userList);
  }
}
